<template>
  <div>
    <h2 class="text-center my-4">Закрепить заказ за Работником</h2>
    <div class="table">
      <div class="table-container">
        <table class="tableText">
          <tr class="table-header">
            <td>id</td>
            <td>ФИО</td>
            <td>Телефон</td>
            <td>Статус</td>
            <td>Кол-во заказов:</td>
            <td>Добавить заказ?</td>
          </tr>
          <tr v-for="man in deliveryMans" :key="man.id">
            <td>{{ man.id }}</td>
            <td>{{ man.full_name }}</td>
            <td>{{ man.phone }}</td>
            <td>На смене</td>
            <td>{{ man.active_orders_count }}</td>
            <td>
              <button @click="assignOrder(man)"><span class="p-2 m-0">+</span></button>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <section class="p-2 col-md-8 mx-auto">
      <b-alert
        :show="dismissCountDown"
        dismissible
        fade
        :variant="variant"
        @dismissed="dismissCountDown=0"
        @dismiss-count-down="countDownChanged"
      >
        <p>{{ alertMessage }}</p>
        <b-progress
          :variant="variant"
          :max="dismissSecs - 1"
          :value="dismissCountDown - 1"
          height="4px"
        ></b-progress>
      </b-alert>
    </section>

    <div id="guestinfo" v-if="orderIsTaken">
      <div class="overlay"></div>
      <div class="visible_msg">
        <div id="endcontent" class="content">
          <section class="px-3">
            <div class="logo">
              <h2 class="mr-5">Заказ уже взят</h2>
              <button @click="back()" style="margin-left: auto;">Назад в Доставку</button>
            </div>
            <div style="height: 400px">
              <yandex-map
                :coords="coords"
                :zoom="15"
              >
                <ymap-marker
                  :coords="coords"
                />
              </yandex-map>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'Action',
  data() {
    return {
      dismissSecs: 5,
      dismissCountDown: 0,
      variant: '',
      alertMessage: '',
      deliveryMans: [],
      merchantHash: null,
      restId: null,
      orderId: null,
      orderIsTaken: false,
      coords: [
        54.82896654088406,
        39.831893822753904,
      ],
    };
  },
  mounted() {
    this.merchantHash = this.$store.state.merchantHash;
    this.restId = this.$store.state.restId;
    this.orderId = this.$store.state.orderId;

    this.$store.commit('updateRestInfo', {
      merchantHash: this.merchantHash,
      restId: this.restId,
    });
    axios
      .post(`//${window.location.host}/api/v1/orders/update`, {
        merchantHash: this.merchantHash,
        restId: this.restId,
      })
      .then((response) => {
        // eslint-disable-next-line no-console
        console.log(response.data);
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.log(error);
      });

    this.updateActiveMans();
    setInterval(this.updateActiveMans, 1000 * 60);

    axios
      .post(`//${window.location.host}/api/v1/order-info`, {
        merchantHash: this.$store.state.merchantHash,
        restId: this.$store.state.restId,
        // eslint-disable-next-line radix
        orderId: parseInt(this.orderId),
      })
      .then((response) => {
        // eslint-disable-next-line no-console
        console.log(response.data);
        this.orderIsTaken = response.data.data[0].delivery_man != null;
        if (this.orderIsTaken === true) {
          axios
            .post(`//${window.location.host}/api/v1/man-coords`, {
              merchantHash: this.$store.state.merchantHash,
              restId: this.$store.state.restId,
              manId: response.data.data[0].delivery_man.id,
            })
            .then((_response) => {
              // eslint-disable-next-line no-console
              console.log(_response.data);
              this.coords = [
                _response.data.data[0].latitude,
                _response.data.data[0].longitude,
              ];
            })
            .catch((error) => {
              // eslint-disable-next-line no-console
              console.log(error);
            });
        }
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.log(error);
      });
  },
  methods: {
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    showAlert(variant) {
      this.variant = variant;
      this.dismissCountDown = this.dismissSecs;
    },
    back() {
      history.back();
    },
    updateActiveMans() {
      axios
        .post(`//${window.location.host}/api/v1/mans/active`, {
          merchantHash: this.$store.state.merchantHash,
          restId: this.$store.state.restId,
        })
        .then((response) => {
          // eslint-disable-next-line no-console
          console.log(response.data);
          this.deliveryMans = response.data.data;
        })
        .catch((error) => {
          // eslint-disable-next-line no-console
          console.log(error);
        });
    },
    assignOrder(man) {
      axios
        .post(`//${window.location.host}/api/v1/order-assign`, {
          merchantHash: this.merchantHash,
          restId: this.restId,
          // eslint-disable-next-line radix
          orderId: parseInt(this.orderId),
          manId: man.id,
        })
        .then((response) => {
          // eslint-disable-next-line no-console
          console.log(response.data);
          if (response.data.success) {
            this.alertMessage = 'Заказ успешно закреплен за Работником!';
            this.showAlert('success');
            // eslint-disable-next-line no-param-reassign
            man.active_orders_count += 1;
          } else {
            this.alertMessage = `Ошибка: ${response.data.error}`;
            this.showAlert('warning');
          }
        })
        .catch((error) => {
          // eslint-disable-next-line no-console
          console.log(error);
          this.alertMessage = 'Неизвестная ошибка.';
          this.showAlert('danger');
        });
    },
  },
};
</script>

<style scoped>
  .ymap-container {
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/Action.vue